import * as THREE from 'three'

const AMBIENT_INTENSITY = 0.6
const KEY_LIGHT_INTENSITY = 1.0

export type SceneEnvironment = { dispose: () => void }

export function applySceneEnvironment(scene: THREE.Scene): SceneEnvironment {
  const ambient = new THREE.AmbientLight(0xffffff, AMBIENT_INTENSITY)
  scene.add(ambient)

  const key = new THREE.DirectionalLight(0xffffff, KEY_LIGHT_INTENSITY)
  key.position.set(5, 10, 7.5)
  scene.add(key)

  return {
    dispose() {
      scene.remove(ambient)
      scene.remove(key)
      ambient.dispose()
      key.dispose()
    },
  }
}
